// extracted by mini-css-extract-plugin
module.exports = {"emailContainer":"styles_emailContainer__2kMpA","updateFooter":"styles_updateFooter__et8QZ"};